import { forkJoin } from 'rxjs/observable/forkJoin';
import { HostService } from './../../providers/host/host.service';
import { IngredientService } from './../../providers/ingredient/ingredient.service';
import { Component } from '@angular/core';
import { ProductService } from '../../providers/product/product.service';
import { NavController, ViewController, NavParams, ToastController } from 'ionic-angular';
@Component({
    selector: 'personalize-menu-product',
    templateUrl: 'personalize-menu-product.html'
})
export class PersonalizeMenuProductComponent {
    activeStep = 1;
    product: any = {};
    host = "";
    filterOpt = "";
    filterSupp = "";
    unavComp = 0;
    unavSupp = 0;
    unavOpt = 0;
    optChecked: number = 0;
    loadAvatar: boolean;
    k = -1;
    m: number = 0;
    loading = true;
    currency = "€";
    language = localStorage.getItem('language');
    constructor(
        private hostService: HostService,
        private productService: ProductService,
        private ingredientsService: IngredientService,
        private viewCtrl: ViewController,
        params: NavParams,
        private toastCtrl: ToastController
    ) {
        this.currency = localStorage.getItem('currency');
        this.product = params.get('product');
        this.host = this.hostService.host2,
            this.optChecked = 0;
    }
    previous() {
        this.activeStep--;
    }
    next() {
        this.activeStep++;
    }
    ngOnInit() {
        setTimeout(
            () => {
                this.getOptions();
                this.getSupplements();
            }, 100
        )

        setTimeout(
            () => {
                forkJoin([
                    this.getCompositions(),
                    this.getOptions(),
                    this.getSupplements(),
                    this.getOptionsObligatoir()
                ]).subscribe(
                    (data: any[]) => {
                        this.loading = false;
                        this.product.compositions = data[0].map(p => {
                            p.label = p.text;
                            p.checked = true
                            return p;
                        })
                        this.unavComp = this.product.compositions.filter(comp => comp.disabled == 'true').length;
                        this.product.optionIngredients = data[1].map(p => {
                            p.label = p.text;
                            return p;
                        })
                        this.unavOpt = this.product.optionIngredients.filter(opt => opt.disabled == 'true').length;
                        this.product.selectedOpt = [];
                        this.product.supplements = data[2].map(p => {
                            p.label = p.text;
                            return p;
                        })
                        this.unavSupp = this.product.supplements.filter(supp => supp.disabled == 'true').length;
                        this.product.selectedSupp = [];
                        this.product.obligatoryIngredient = [];
                        this.product.obligatoryIngredient = data[3];
                    }
                )
            }, 100
        )
    }
    expandItem(i) {
        this.k = (this.k == i) ? -1 : i;
    }
    getCompositions() {
        return this.productService.getProductCompositions(this.product.element);
    }

    getOptions() {
        return this.productService.getProductOptionsIngredient(this.product.element)
    }
    getSupplements() {
        return this.productService.getProductSupplements(this.product.element)
    }
    getOptionsObligatoir() {
        return this.ingredientsService.getObligatoryIngredientOfProduct(this.product.element);
    }
    changeOption(opt) {
        if (opt.checked) {
            this.optChecked++;
        } else {
            this.optChecked--;
        }
    }
    valider() {
        let error = 0;
        let product = JSON.parse(JSON.stringify(this.product));
        if (product.custom) {
            product.selectedOpt = this.product.optionIngredients.filter(c => c.disabled == "false" && c.checked);
            if (product.selectedOpt.length == 0) {
                error++;
                if(this.language == "eng"){
                    this.displayMessage('Please add options');
                }
                if(this.language == "fr"){
                this.displayMessage('Merci d\'ajouter les options');
                }
                return;
            } else {
                product.obligatoryIngredient.forEach(cat => {
                    let array = product.selectedOpt.filter(o => o.category == cat.id);
                    if (error == 0 && array.length < cat.maxNbrIngOptions) {
                        error++;
                        if(this.language == "eng"){
                            this.displayMessage('Please select at least ' + cat.maxNbrIngOptions + ' ingredient(s) of the category ' + cat.category);
                        }
                        if(this.language == "fr"){
                        this.displayMessage('Merci de selectionner au moins ' + cat.maxNbrIngOptions + ' ingredient(s) de la categorie ' + cat.category);
                        }
                        return;
                    }
                });
            }
        }
        if (error == 0) {
            let data: any = true;
            this.viewCtrl.dismiss(data)
        }


    }
    closeModal() {
        this.viewCtrl.dismiss();
    }
    displayMessage(message) {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }
}



// WEBPACK FOOTER //
// ./src/components/personalize-menu-product/personalize-menu-product.ts